import { AuthenticationResult } from '@azure/msal-browser';

import { apiUrl } from '../envUtil';
import { APIRequest } from '../apiUtil';
import { Mixpanel } from 'utils/mixPanelUtil';

import {
    IntegrationCredentialType,
    IntegrationServiceTypeEnum,
    IntegrationTypeEnum,
} from 'types/integrationCredential';

export const swapGoogleCodeWithTokenForIntegrationAccess = (
    code: string,
    service_type: IntegrationServiceTypeEnum
) => {
    Mixpanel.track('app.swap_google_code_with_token_for_integration_access', {});

    return APIRequest({
        method: 'post',
        url: apiUrl + `integration-credential/process-google-auth-code`,
        data: { code, service_type },
    });
};

export const processMSGraphAuthPayload = (payload: AuthenticationResult) => {
    Mixpanel.track('app.process_msgraph_auth_payload', {});

    return APIRequest({
        method: 'post',
        url: apiUrl + `integration-credential/process-msgraph-auth-payload`,
        data: { payload },
    });
};

export const getMSGraphAuthURLIntegrationAccess = (service_type: IntegrationServiceTypeEnum) => {
    Mixpanel.track('app.get_msgraph_auth_url', { service_type });

    return APIRequest({
        method: 'get',
        url: apiUrl + `integration-credential/msgraph-auth-url?service_type=${service_type}`,
    });
};

export const updateIntegrationCredential = (formValues: Partial<IntegrationCredentialType>) => {
    Mixpanel.track('app.update_integration_credential', {
        integration_type: formValues.integration_type,
    });

    return APIRequest({
        method: 'put',
        url: apiUrl + `integration-credential`,
        data: { ...formValues },
        useDefaultErrorNotif: true,
    });
};

export const requestNew3rdPartyIntegrationAccessToken = (integration_type: IntegrationTypeEnum) => {
    return APIRequest({
        method: 'post',
        url: apiUrl + `integration-credential/request-access-token/${integration_type}`,
    });
};

export const getMyIntegrationCredentials = (integration_type?: IntegrationTypeEnum) => {
    return APIRequest({
        method: 'get',
        url: apiUrl + `integration-credentials?integration_type=${integration_type}`,
    });
};

export const googleLogout = (email: string) => {
    return APIRequest({
        method: 'post',
        url: apiUrl + `integration-credential/google-logout`,
        data: { email },
        useDefaultErrorNotif: true,
    });
};

export const generateLogoutCallbackURL = (
    integration_type: IntegrationTypeEnum,
    emailToLogout?: string
) => {
    return APIRequest({
        method: 'post',
        url: apiUrl + `integration-credential/create-logout-callback-url`,
        data: { integration_type, email_to_logout: emailToLogout },
        useDefaultErrorNotif: true,
    });
};

export const logoutByProvider = (
    provider: IntegrationTypeEnum,
    email: string,
    service_type?: IntegrationServiceTypeEnum
) => {
    return APIRequest({
        method: 'post',
        url:
            apiUrl +
            `integration-credentials/${
                provider === IntegrationTypeEnum.GOOGLE ? 'google' : 'microsoft'
            }/logout`,
        data: { email, service_type },
        useDefaultErrorNotif: true,
    });
};
